import { Banner } from '@workspace/ui/components/banner'
import { Button } from '@workspace/ui/components/button'
import { Check, Copy, Share2 } from 'lucide-react'
import { useState } from 'react'

interface CopyLinkBannerProps {
  shareUrl: string
  description: string
  actions?: React.ReactNode
}

export function CopyLinkBanner({ shareUrl, description, actions }: CopyLinkBannerProps) {
  const [copied, setCopied] = useState(false)

  const handleCopy = async () => {
    await navigator.clipboard.writeText(shareUrl)
    setCopied(true)
    setTimeout(() => setCopied(false), 2000)
  }

  return (
    <Banner
      variant="success"
      icon={<Share2 className="size-4.5" />}
      title="SeedForge Link Active"
      description={description}
    >
      <div className="flex items-center gap-2 px-4 pb-4">
        <div className="hidden sm:flex flex-1 h-8 items-center rounded-lg border border-emerald-500/20 bg-black/20 px-3.5 font-mono text-sm text-white/80 truncate">
          {shareUrl}
        </div>
        <Button
          variant="outline"
          size="sm"
          onClick={handleCopy}
          className="shrink-0 border-emerald-500/20 hover:bg-emerald-500/10"
        >
          {copied ? <Check className="size-4 text-emerald-400" /> : <Copy className="size-4" />}
          {copied ? 'Copied!' : 'Copy Link'}
        </Button>
        {actions}
      </div>
    </Banner>
  )
}
